import React from 'react'

import styles from './HotspotMini.module.scss'

const HotspotMini = () => <div className={styles.HotspotMini} />

export default HotspotMini
